import React from 'react';
import { StreamingEarningsSummary } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { EarningsAmounts } from './EarningsAmounts';
import { EarningsEmptyCard } from './EarningsEmptyCard';
import { EarningsHiddenCard } from './EarningsHiddenCard';

interface EarningsSummaryBodyProps {
  earnings: StreamingEarningsSummary;
  /** The kinds of source that report earnings, for the line of the empty card. */
  givenBy: readonly string[];
  onOpenCatalog: () => void;
}

/**
 * Picks the state of the earnings (design e1, e2, e3): the plan card (Free), the member card, no source with earnings, no
 * whole month in the period, nothing reported, or the amounts of each currency.
 */
const EarningsSummaryBodyComponent: React.FC<EarningsSummaryBodyProps> = ({ earnings, givenBy, onOpenCatalog }) => {
  if (earnings.hidden) {
    return <EarningsHiddenCard reason={earnings.hiddenReason} />;
  }
  if (!earnings.connected) {
    return <EarningsEmptyCard kind="noSource" givenBy={givenBy} onOpenCatalog={onOpenCatalog} />;
  }
  if (earnings.months === null) {
    return <EarningsEmptyCard kind="noMonth" onOpenCatalog={onOpenCatalog} />;
  }
  if ((earnings.amounts ?? []).length === 0) {
    return <EarningsEmptyCard kind="nothing" months={earnings.months} onOpenCatalog={onOpenCatalog} />;
  }
  return <EarningsAmounts earnings={earnings} />;
};

export const EarningsSummaryBody = TypedMemo(EarningsSummaryBodyComponent);
